import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-3 flex flex-col gap-2 border-t border-slate-100 pt-3 sm:flex-row sm:items-center sm:justify-between"
}
const _hoisted_2 = { class: "text-xs font-semibold text-slate-500" }
const _hoisted_3 = { class: "flex items-center gap-2" }
const _hoisted_4 = { class: "inline-flex h-8 min-w-16 items-center justify-center rounded-lg bg-slate-50 px-3 text-xs font-bold text-slate-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiButton = _resolveComponent("UiButton")!

  return ($props.total > $props.pageSize)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, " Hiển thị " + _toDisplayString($setup.startItem) + "-" + _toDisplayString($setup.endItem) + " / " + _toDisplayString($props.total), 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_UiButton, {
            variant: "secondary",
            size: "sm",
            icon: "prev",
            disabled: $props.modelValue <= 1,
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.emitPage($props.modelValue - 1)))
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode(" Trước ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled"]),
          _createElementVNode("span", _hoisted_4, _toDisplayString($props.modelValue) + " / " + _toDisplayString($setup.pageCount), 1),
          _createVNode(_component_UiButton, {
            variant: "secondary",
            size: "sm",
            icon: "next",
            disabled: $props.modelValue >= $setup.pageCount,
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.emitPage($props.modelValue + 1)))
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode(" Sau ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]))
    : _createCommentVNode("", true)
}